<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    // window.document.documentElement.setAttribute(
    //     "data-theme",
    //     JSON.parse(this.$cookie.get('indexPage')=='GISOverview') ? "light" : "dark"
    // );
  },
};
</script>

<style>
#app {
  /*font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;*/
  overflow: hidden;
}
</style>
